import { defineComponent as _defineComponent } from 'vue'
import { cva, type VariantProps } from 'class-variance-authority'
import { twMerge } from 'tailwind-merge'

interface ButtonProps {
  as?: string
  variant?: VariantProps<typeof buttonVariants>['variant']
  size?: VariantProps<typeof buttonVariants>['size']
  twClass?: string | string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    as: { default: 'button' },
    variant: { default: 'default' },
    size: { default: 'default' },
    twClass: { default: undefined }
  },
  setup(__props: any) {

const buttonVariants = cva(
  'inline-flex items-center justify-center rounded-md text-sm font-semibold ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:!no-underline',
  {
    variants: {
      variant: {
        default: 'shadow-sm bg-primary-500 !text-white hover:bg-primary-600',
        outline:
          'shadow-sm bg-white text-gray-900 border-solid border border-gray-300 hover:bg-gray-50',
        blur: 'shadow-sm transition-opacity backdrop-blur-sm',
        ghost: 'bg-transparent text-gray-900 hover:bg-gray-50',
      },
      size: {
        default: 'px-3 py-2',
        icon: 'p-1',
        xs: 'px-2 py-1 text-xs',
        sm: 'px-2.5 py-1.5',
        lg: 'px-3.5 py-2.5',
      },
    },
  },
)



return { __sfc: true,buttonVariants, twMerge }
}

})